import { Navigate } from "@tanstack/react-router";
import type { ReactNode } from "react";
import { hasRole, useCurrentUser } from "../hooks/useAuth.js";

interface RequireAdminProps {
  children: ReactNode;
}

/**
 * Rollen-Guard für Admin-Seiten — Gegenstück zu AuthGuard, eine Ebene tiefer:
 * AuthGuard prüft, *ob* jemand eingeloggt ist, RequireAdmin *wer*.
 *
 * Ohne diesen Guard reicht es nicht, den Nav-Link auszublenden
 * (AppLayout.tsx): der direkte URL-Aufruf erreicht die Seite trotzdem. Die
 * Daten sind serverseitig geschützt (requireRole → 403), die Hülle war es
 * nicht.
 */
export function RequireAdmin({ children }: RequireAdminProps) {
  const { user, isLoading } = useCurrentUser();

  if (isLoading) {
    return null;
  }

  if (!hasRole(user, "admin")) {
    return <Navigate to="/settings" />;
  }

  return <>{children}</>;
}
